import { FREE_EXCLUDED, FREE_INCLUDED, TRIAL_INCLUDED } from '../constants';
import { FeatureList } from './FeatureList';
import { GreenCheckIcon, RedXIcon } from './icons';

export const TrialFeaturesList = () => (
  <FeatureList
    items={TRIAL_INCLUDED.map((text) => ({
      icon: <GreenCheckIcon />,
      text,
    }))}
  />
);

export const FreeFeaturesList = () => (
  <FeatureList
    items={FREE_INCLUDED.map((text) => ({
      icon: <GreenCheckIcon />,
      text,
    }))}
  />
);

export const PaidFeaturesList = () => (
  <FeatureList
    items={FREE_EXCLUDED.map((text) => ({
      icon: <RedXIcon />,
      text,
    }))}
  />
);
